import { forwardRef } from 'react';
import type { Ref } from 'react';

import FormLabel, { FormLabelVariant } from './FormLabel';
import TextInput from './TextInput';
import type { TextInputProps } from './TextInput';

export type LabeledTextInputProps = TextInputProps & {
  /**
   * Optionally provide a variant which the label should be. You shouldn't ever need to use this, unless the design specifically calls for this variant. Otherwise we should use default styling everywhere.
   */
  labelVariant?: FormLabelVariant;
};

/**
 * Wraps a TextInput with a label. Displays the label above the <input />, with optional required text.
 */
const LabeledTextInput = forwardRef<HTMLInputElement, LabeledTextInputProps>(({
  label,
  isRequired,
  labelVariant = FormLabelVariant.Default,
  ...textInputProps
}: LabeledTextInputProps, ref: Ref<HTMLInputElement>) => (
  <FormLabel
    label={label}
    requiredText={isRequired ? '(Required)' : undefined}
    variant={labelVariant}
  >
    <TextInput
      ref={ref}
      label={label}
      isRequired={isRequired}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...textInputProps}
    />
  </FormLabel>
));

export default LabeledTextInput;
